import DataModel from '@ember-data/model';
import {
  FilterId,
  FilterOptionsType,
  MultiSelectFilter,
} from 'uplisting-frontend/utils/filters/abstract';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export class ClientNameFilter extends MultiSelectFilter<
  ModelRegistry['client']
> {
  id = FilterId.clientName;
  optionsType = FilterOptionsType.store;
  modelName = 'client';
  modelField = 'name' as keyof DataModel;
}
